import style from "./input.module.scss";
import { Form } from "react-bootstrap";
import WarningCard from "../WarningCard";
import InputMask from 'react-input-mask';
import { InputHTMLAttributes } from "react";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

type InputProps = {
  inputName: string;
  label: string;
  mask?: string;
  disabled?: boolean;
  validators?: any;
  form: any;
  type?: InputHTMLAttributes<HTMLInputElement>['type'];
  required?: boolean;
  showPasswordToggle?: boolean;
};

export function Input({
  inputName,
  label,
  form,
  validators,
  disabled,
  mask,
  type,
  required,
  showPasswordToggle,
}: InputProps) {
  const { register, formState: { errors } } = form;
  const validatorsKeys = Object.keys(validators || {});
  const [passwordVisible, setPasswordVisible] = useState(false);

  const toggleEnabled =
    Boolean(showPasswordToggle) && !mask && type === "password";

  const effectiveType =
    toggleEnabled && passwordVisible ? "text" : type;

  const baseInputClass = `${style.input} ${errors[inputName] ? style.fieldError : ""} ${
    toggleEnabled ? style.inputWithToggle : ""
  }`.trim();

  const passwordToggleButton = toggleEnabled ? (
    <button
      type="button"
      tabIndex={0}
      className={style.toggleBtn}
      aria-label={passwordVisible ? "Ocultar senha" : "Mostrar senha"}
      onClick={() => setPasswordVisible((v) => !v)}
      disabled={disabled}
    >
      {passwordVisible ? (
        <FaEyeSlash size={18} aria-hidden />
      ) : (
        <FaEye size={18} aria-hidden />
      )}
    </button>
  ) : null;

  const plainInput = (
    <input
      id={inputName}
      className={baseInputClass}
      disabled={disabled}
      style={{ width: "100%" }}
      type={effectiveType}
      {...register(inputName, validators)}
    />
  );

  return (
    <Form.Group className={`${label ? "mt-4 mb-2" : ""}`} controlId="formGroupName" style={{ width: "100%" }}>
      {label && <Form.Label>{label}</Form.Label>}

      {mask ?
        <InputMask id={inputName} className={`${style.input} ${errors[inputName] ? style.fieldError : ''}`} mask={mask} maskPlaceholder={""} style={{ width: "100%", }} disabled={disabled}  {...register(inputName, validators)} /> :
        toggleEnabled ? (
          <div className={style.toggleWrap}>
            {plainInput}
            {passwordToggleButton}
          </div>
        ) : (
          plainInput
        )
      }

      {validatorsKeys.map((key) => {
        if (errors[inputName] && errors[inputName].type === key) {
          return (
            <WarningCard
              key={key}
              errorMessage={`error${inputName.charAt(0).toUpperCase() + inputName.slice(1)}`}
              dynamicMessage={
                typeof errors[inputName]?.message === "string"
                  ? errors[inputName].message
                  : undefined
              }
            />
          );
        }

        return <div key={key}></div>;
      })}
    </Form.Group>
  );
}
